import { UserPreferencesSchema } from '@app/core/api/user-preferences';

/**
 * User preferences state interface for NgRx store
 */
export interface UserPreferencesState {
  preferences: UserPreferencesSchema | null;
  loading: boolean;
  error: string | null;
  cacheTimestamp: number | null;
}

/**
 * Initial state for user preferences feature
 */
export const initialUserPreferencesState: UserPreferencesState = {
  preferences: null,
  loading: false,
  error: null,
  cacheTimestamp: null
};
